export default __webpack_public_path__ + "static/media/3073.c2889bc2.jpg";